import { forwardRef } from 'react';
import { StyledHolder, StyledAvatar } from './styled';

const Avatar = forwardRef((props, ref) => {
  const { src } = props;

  if (src) {
    return <StyledAvatar ref={ref} {...props} />;
  } else {
    return <StyledHolder ref={ref} {...props} />;
  }
});

export default Avatar;
